import { Helmet } from "react-helmet";

const AdvertisingBook = () => {

    return (
        <>
        <Helmet>
            <script>window.yaContextCb=window.yaContextCb||[]</script>
            <script src="https://yandex.ru/ads/system/context.js" async></script>
            <script>
               {
                `window.yaContextCb.push(() => {
                    Ya.Context.AdvManager.render({
                        "blockId": "R-A-15668328-2",
                        "renderTo": "yandex_rtb_R-A-15668328-2"
                        })
                    })`
                }
            </script>
        </Helmet>
        <div className="advertising-book">
            <div id={`yandex_rtb_R-A-15668328-2`}></div>
        </div>
    </>);

}

export default AdvertisingBook;